import { CKContainerProps, CKLayoutHorizontal } from 'clearkit';
import { FC } from 'react';

export const ButtonContainer: FC<CKContainerProps> = ({ ...rest }) => (
  <CKLayoutHorizontal {...rest} as="footer" justifyContent="end" />
);
